module.exports = __webpack_public_path__ + "img/grader-icon0.ed86309e.png";